<template>
  <div class="zhuangMenKanBan">
    <h1 style="text-align:center; margin-top: 0vh; line-height: 8vh;">装门区域看板</h1>
    <div style="width: 59%; float: left; margin-left: 1%;">
      <div style="background-color: #2D4054; width: 100%;">
        <div style="font-size: 3vh; float: left; margin: 1vh 0 0 1vh; position: absolute; z-index: 999;">* 装门</div>
        <div class="chart1" style="width: 47%; height: 30vh; float: left; margin-left: 6%;"/>
        <div class="chart2" style="width: 47%; height: 30vh; float: left;"/>
        <div class="clear"/>
      </div>
      <div style="background-color: #2D4054; width: 100%; margin-top: 1vh;">
        <div style="width: 30%; float: left; font-size: 2vh;">
          <div style="font-size: 3vh; float: left; margin: 1vh 0 0 1vh;">* 检验</div>
          <div class="clear"/>
          <div style="line-height: 6vh;">
            <div style="font-size: 2.6vh;">待办：</div>
            <div style="font-size: 3vh;">{{WJY}}</div>
          </div>
          <div style="color: #ED7058; line-height: 6vh; font-size: 2.6vh;">
            <div style="font-size: 2.6vh;">不合格：</div>
            <div style="font-size: 3vh;">{{BHG}}</div>
          </div>
        </div>
        <div style="width: 70%; float: right;">
          <el-table :data="List" height="29vh" size="medium" style="font-size: 2.6vh;">
            <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.6)"/>
            <el-table-column prop="materialDescription" label="柜型"/>
          </el-table>
        </div>
        <div class="clear"/>
      </div>
      <div style="background-color: #2D4054; width: 100%; margin-top: 1vh; font-size: 2vh;">
        <div style="font-size: 3vh; float: left; margin: 1vh 0 0 1vh; position: absolute; z-index: 999;">* 入库</div>
        <div style="float: left; width: 30%; margin: 3% 0% 3% 20%; ">
          <div style="background-color: #2980C6; width: 100%; height: 15vh; border-radius: 0.6vh;">
            <div style="line-height: 8vh; font-size: 4vh;">{{WRK}}</div>
            <div style="line-height: 4vh; font-size: 3vh;">已检验未入库</div>
          </div>
        </div>
        <div style="float: right; width: 30%; margin: 3% 10%;">
          <div style="background-color: #F4A35F; width: 100%; height: 15vh;border-radius: 0.6vh;">
            <div style="line-height: 8vh; font-size: 4vh;">{{YRK}}</div>
            <div style="line-height: 4vh; font-size: 3vh;">已入库</div>
          </div>
        </div>
        <div class="clear"/>
      </div>
    </div>
    <div style="width: 39%; float: right; margin-left: 1%;">
      <div>
        <el-table :data="DZMList" height="29vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.6)"/>
          <el-table-column prop="materialDescription" label="柜型"/>
        </el-table>
      </div>
      <div style="margin-top: 1vh;">
        <el-table :data="DJYList1" height="29vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.6)"/>
          <el-table-column prop="materialDescription" label="柜型"/>
        </el-table>
      </div>
      <div style="margin-top: 1vh;">
        <el-table :data="DRKList" height="28vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.6)"/>
          <el-table-column prop="materialDescription" label="柜型"/>
        </el-table>
      </div>
    </div>
    <div class="clear"/>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        date: new Date().getTime(),
        ZMZS: 0,
        YZM: 0,
        WZP: 0,
        WJY: 0,
        BHG: 0,
        WRK: 0,
        YRK: 0,
        myChart1: null,
        myChart2: null,
        DZMList: [],
        DJYList: [],
        DJYList1: [],
        DRKList: [],
        List: [],
      };
    },
    mounted() {
      this.getSpAssemblingList();
      this.getDZMList();
      this.getDJYList();
      this.getDRKList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      setInterval(() => {
        this.getSpAssemblingList();
        this.getDZMList();
        this.getDJYList();
        this.getDRKList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 5);
      setInterval(() => {
        this.DZMList.push(this.DZMList[0]);
        this.DZMList.splice(0, 1);
        this.DJYList.push(this.DJYList[0]);
        this.DJYList.splice(0, 1);
        this.DRKList.push(this.DRKList[0]);
        this.DRKList.splice(0, 1);
        this.List.push(this.List[0]);
        this.List.splice(0, 1);
      }, 4000);
    },
    methods: {
      getSpAssemblingList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getSpAssemblingList", params).then(res => {
          for(let item of res) {
            if(item.name === "装门总数") {
              this.ZMZS = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "已装门数量") {
              this.YZM = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "未装配数量") {
              this.WZP = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "未检验数量") {
              this.WJY = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "不合格数量") {
              this.BHG = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "未入库数量") {
              this.WRK = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "已入库数量") {
              this.YRK = (item.bl === null ? 0 : item.bl);
            }
          }
          this.$nextTick(() => {
            this.refreshChart();
          });
        });
      },
      getDZMList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getDZMList", params).then(res => {
          this.DZMList = res;
        });
      },
      getDJYList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getDJYList", params).then(res => {
          this.DJYList = res;
        });
      },
      getDRKList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getDRKList", params).then(res => {
          this.DRKList = res;
        });
      },
      refreshChart() {
        let option1 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n已办：\n " + this.YZM + "\n\n总数：\n " + this.ZMZS,
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.YZM/this.ZMZS, this.YZM/this.ZMZS],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.YZM + "\n\n" + Math.round(this.YZM * 100/this.ZMZS) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart1.setOption(option1);

        let option2 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n\n待办：\n  " + this.WZP,
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(246,159,104)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.WZP/this.ZMZS, this.WZP/this.ZMZS],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.WZP + "\n\n " + Math.round(this.WZP * 100/this.ZMZS) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#F69F68",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart2.setOption(option2);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .zhuangMenKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar, ::-webkit-scrollbar-track {
      background-color: transparent!important;
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .clear{
      clear:both
    }
  }
</style>
